module.exports = __webpack_public_path__ + "static/media/poland.3cbc86d2.jpg";